goog.provide("shadow.js.shim.module$react_bootstrap$Overlay$default");
shadow.js.shim.module$react_bootstrap$Overlay$default = shadow.js.require(207, {})["default"];
